<script setup lang="ts">
const tabs = [
  {
    value: 'tab-1',
    label: 'Cara Mendapatkan Poin',
    title: 'Cara Mendapatkan Poin',
    description: 'Segera kumpulkan poinmu untuk dapat hadiah menarik.',
    image_url: '/assets/batch-2/artboard/ka-poin-artboard-new.webp',
    steps: [
      {
        title: 'Gabung KiriminAja Poin',
        description:
          'Daftarkan dirimu melalui aplikasi atau dashboard KiriminAja dan lengkapi data yang dibutuhkan.'
      },
      {
        title: 'Dapatkan Poin Pertamamu',
        description:
          'Setelah berhasil mendaftar program KiriminAja Poin, kamu akan langsung mendapatkan poin.'
      },
      {
        title: 'Kirim Paket, Kumpulkan Poinnya',
        description:
          'Mulai kirim paketmu dan kamu akan mendapatkan poin sesuai jenis layanan pengiriman yang digunakan.'
      },
      {
        title: 'Kirim Lebih Banyak, Untung Lebih Banyak',
        description:
          'Setiap paket yang selesai dikirim akan terus memberikan tambahan poin untuk ditukar dengan berbagai macam hadiah.'
      }
    ]
  },
  {
    value: 'tab-2',
    label: 'Cara Menukarkan Poin',
    title: 'Cara Menukarkan Poin',
    description:
      'Tukar poin yang kamu miliki, langsung dapat hadiah tanpa diundi.',
    image_url: '/assets/batch-2/artboard/ka-poin-artboard-new.webp',
    steps: [
      {
        title: 'Pilih Hadiahmu',
        description:
          'Pastikan poin yang kamu kumpulkan sudah cukup untuk ditukar dengan hadiah yang kamu inginkan.'
      },
      {
        title: 'Tukarkan Poinmu',
        description:
          'Cek syarat dan ketentuan penukaran hadiah kemudian tukarkan poin yang sudah dikumpulkan dengan hadiah pilihanmu.'
      },
      {
        title: 'Konfirmasi Detail Pengiriman Hadiahmu',
        description:
          'Tim KiriminAja akan menghubungimu untuk konfirmasi pengiriman hadiah. Prosesnya akan dilakukan dalam waktu maksimal tujuh hari kerja.'
      }
    ]
  }
]
</script>

<template>
  <UiContainer class="flex flex-col gap-11 py-7 lg:py-12">
    <UiTabBase
      wrapper-class="border-b-2"
      trigger-wrapper-class="w-full justify-evenly"
      :tabs="tabs"
      default-value="tab-1"
    >
      <template v-for="(tab, index) in tabs" :key="index" #[tab.value]>
        <UiSectionWrapper
          class="pt-6"
          image-class="lg:order-first"
          :title="tab.title"
          :description="tab.description"
          :hero-image="tab.image_url"
          container-full-width
        >
          <template #action>
            <div class="mt-6 flex flex-col gap-6 text-lg leading-7">
              <div
                v-for="(step, stepIndex) in tab.steps"
                :key="stepIndex"
                class="flex gap-2 lg:gap-4"
              >
                <div
                  class="flex-none w-8 h-8 rounded-full flex justify-center items-center bg-primary-container"
                >
                  <span class="text-primary font-bold">{{
                    stepIndex + 1
                  }}</span>
                </div>
                <div class="flex-1 flex flex-col gap-2">
                  <h5 class="text-base lg:text-lg font-bold">
                    {{ step.title }}
                  </h5>
                  <p class="text-sm lg:text-base text-on-surface-variant">
                    {{ step.description }}
                  </p>
                </div>
              </div>
            </div>
          </template>
        </UiSectionWrapper>
      </template>
    </UiTabBase>

    <div class="flex justify-center items-center">
      <UiButton
        :to="
          $utm.utmUrl('/register', {
            redirectTo: '/kiriminaja-point'
          })
        "
        label="Mulai Kumpulkan Poin"
      />
    </div>
  </UiContainer>
</template>
